import ServiceList from "./ServiceList";

class InitCardsService {
  static List: any;
  static group: any;
  static init() {
    this.List = this.List ? this.List : new ServiceList("thirdApp.db", "cards");
  }
  static clearServiceAll() {
    this.List?.destory();
    this.List = null;
  }
  static GetListService() {
    return this.List || new ServiceList("thirdApp.db", "cards");
  }
  static setGroup(group: any) {
    this.group = group;
  }
}

export default InitCardsService;
